import { redirect } from '@respond-framework/rudy';
import { PORTAL } from '../resourceNames';
import Resource from '../../resource/Resource';

import {
  INSTITUTION_SET_WHITE_LABEL_LOGO_URL_START,
  INSTITUTION_SET_WHITE_LABEL_LOGO_URL_SUCCESS,
  INSTITUTION_SET_WHITE_LABEL_LOGO_URL_FAILURE,
  INSTITUTION_CREATE_PORTAL_SUCCESS,
  INSTITUTION_CREATE_PORTAL,
  INSTITUTION_CREATE_PORTAL_ERROR,
  INSTITUTION_SET_WHITE_LABEL_LOGO_ENABLED_START,
  INSTITUTION_SET_WHITE_LABEL_LOGO_ENABLED_SUCCESS,
  INSTITUTION_SET_WHITE_LABEL_LOGO_ENABLED_FAILURE,
  INSTITUTION_SET_WHITE_LABEL_ITEM_VISIBILITY_START,
  INSTITUTION_SET_WHITE_LABEL_ITEM_VISIBILITY_SUCCESS,
  INSTITUTION_SET_WHITE_LABEL_ITEM_VISIBILITY_FAILURE,
  INSTITUTION_SET_WHITE_LABEL_VISIBILITY_ROLE_SETTING_START,
  INSTITUTION_SET_WHITE_LABEL_VISIBILITY_ROLE_SETTING_SUCCESS,
  INSTITUTION_SET_WHITE_LABEL_VISIBILITY_ROLE_SETTING_FAILURE,
} from './actions';

import './injectReducers';
import { createPortal } from '../../web/containers/CreateInstitutionPage/helpers';
import { ROUTE_INSTITUTION_ADMIN } from '../routeActions';

export function setWhiteLabelLogoImageUrl(institutionPath, imageUrl) {
  return (dispatch) => {
    dispatch({
      type: INSTITUTION_SET_WHITE_LABEL_LOGO_URL_START,
      institutionPath,
    });

    return Resource.update(
      PORTAL,
      institutionPath,
      'setWhiteLabelLogoImageUrl',
      {
        imageUrl,
      }
    ).then(
      (portal) => {
        dispatch({
          type: INSTITUTION_SET_WHITE_LABEL_LOGO_URL_SUCCESS,
          portalPath: portal.name,
          portal,
        });
      },
      () => {
        dispatch({
          type: INSTITUTION_SET_WHITE_LABEL_LOGO_URL_FAILURE,
          institutionPath,
        });
      }
    );
  };
}

export function setWhiteLabelLogoEnabled(institutionPath, enabled) {
  return (dispatch) => {
    dispatch({
      type: INSTITUTION_SET_WHITE_LABEL_LOGO_ENABLED_START,
      institutionPath,
    });

    return Resource.update(
      PORTAL,
      institutionPath,
      'setWhiteLabelLogoEnabled',
      {
        enabled,
      }
    ).then(
      (portal) => {
        dispatch({
          type: INSTITUTION_SET_WHITE_LABEL_LOGO_ENABLED_SUCCESS,
          portalPath: portal.name,
          portal,
        });
      },
      () => {
        dispatch({
          type: INSTITUTION_SET_WHITE_LABEL_LOGO_ENABLED_FAILURE,
          institutionPath,
        });
      }
    );
  };
}

export function setWhiteLabelItemVisibility(
  institutionPath,
  settingName,
  value
) {
  return (dispatch) => {
    dispatch({
      type: INSTITUTION_SET_WHITE_LABEL_ITEM_VISIBILITY_START,
      institutionPath,
      settingName,
    });

    return Resource.update(
      PORTAL,
      institutionPath,
      'setWhiteLabelItemVisibility',
      {
        settingName,
        value,
      }
    ).then(
      (portal) => {
        dispatch({
          type: INSTITUTION_SET_WHITE_LABEL_ITEM_VISIBILITY_SUCCESS,
          portalPath: portal.name,
          portal,
          settingName,
        });
      },
      () => {
        dispatch({
          type: INSTITUTION_SET_WHITE_LABEL_ITEM_VISIBILITY_FAILURE,
          institutionPath,
          settingName,
        });
      }
    );
  };
}

export function setWhiteLabelItemVisibilityRoleSetting(institutionPath, value) {
  return (dispatch) => {
    dispatch({
      type: INSTITUTION_SET_WHITE_LABEL_VISIBILITY_ROLE_SETTING_START,
      institutionPath,
    });

    return Resource.update(
      PORTAL,
      institutionPath,
      'setWhiteLabelItemVisibilityRoleSetting',
      {
        value,
      }
    ).then(
      (portal) => {
        dispatch({
          type: INSTITUTION_SET_WHITE_LABEL_VISIBILITY_ROLE_SETTING_SUCCESS,
          portalPath: portal.name,
          portal,
        });
      },
      () => {
        dispatch({
          type: INSTITUTION_SET_WHITE_LABEL_VISIBILITY_ROLE_SETTING_FAILURE,
          institutionPath,
        });
      }
    );
  };
}

export const createInstitutionPortal = (
  institutionName,
  institutionPath,
  subscriptionId
) => {
  return (dispatch) => {
    dispatch({
      type: INSTITUTION_CREATE_PORTAL,
    });

    return createPortal(institutionPath, institutionName, subscriptionId).then(
      (result) => {
        if (result === true) {
          dispatch({
            type: INSTITUTION_CREATE_PORTAL_SUCCESS,
            name: institutionName,
            path: institutionPath,
          });

          // redirect user to the institution admin > courses page
          dispatch(
            redirect({
              type: ROUTE_INSTITUTION_ADMIN,
              query: {
                institution: institutionPath,
                action: 'courses',
              },
            })
          );
        } else {
          dispatch({
            type: INSTITUTION_CREATE_PORTAL_ERROR,
            error: result,
          });
        }
      }
    );
  };
};
